import './Demo.scss'
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Button, Container} from "react-bootstrap";
import {useContext} from "react";
import AppContext from "../AppContext";
import {Navigate} from "react-router-dom";

export default function Demo() {
    const app = useContext(AppContext)
    if(!app.user?.demo)
        return <Navigate to="/" />

    return <div id="page-demo" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            <Container className="mt-5">
                <h5 className="text-center text-muted pb-4">Dit is het einde van de demo.</h5>
                <h1 className="text-center title mt-5">
                    VOND JE DE DEMO GOED?
                </h1>
                <p style={{maxWidth: 500, textAlign: 'center', margin: '0 auto'}}>
                    Je kan volledige toegang krijgen tot alle video's, oefenvragen en examens met één van onze pakketten.
                    <br />
                    <br />
                    <Button href="/signup" variant="primary" size="lg">Meld je aan</Button>
                </p>
            </Container>
        </div>
    </div>
}